<script lang="ts" setup>
import { getCSSVariable } from '@/helpers/utils'

interface Props {
  align: 'left' | 'right'
  variant: 'outline' | 'filled'
  color: string
}

withDefaults(defineProps<Props>(), {
  align: 'left',
  variant: 'filled',
  color: getCSSVariable('darkest'),
})

defineOptions({
  inheritAttrs: false,
})
</script>

<template>
  <svg
    v-if="align === 'left' && variant === 'filled'"
    v-bind="$attrs"
    xmlns="http://www.w3.org/2000/svg"
    width="242"
    height="354"
    viewBox="0 0 242 354"
    fill="none"
  >
    <circle cx="65" cy="177" r="177" :fill="color" />
  </svg>
  <svg
    v-if="align === 'left' && variant === 'outline'"
    v-bind="$attrs"
    xmlns="http://www.w3.org/2000/svg"
    width="255"
    height="310"
    viewBox="0 0 255 310"
    fill="none"
  >
    <circle cx="100" cy="155" r="154.5" :stroke="color" />
  </svg>
  <svg
    v-if="align === 'right' && variant === 'filled'"
    v-bind="$attrs"
    xmlns="http://www.w3.org/2000/svg"
    width="179"
    height="232"
    viewBox="0 0 179 232"
    fill="none"
  >
    <circle id="ellipse" cx="116" cy="116" r="116" :fill="color" />
  </svg>
  <svg
    v-if="align === 'right' && variant === 'outline'"
    v-bind="$attrs"
    xmlns="http://www.w3.org/2000/svg"
    width="235"
    height="344"
    viewBox="0 0 235 344"
    fill="none"
  >
    <circle cx="172" cy="172" r="171.5" :stroke="color" />
  </svg>
</template>

<style lang="scss" scoped></style>
